import { ASSET_PREFIX, colors } from "utils/constants";
import GlowBar from "components/GlowBar";
import CardList from "components/CardList";
import GiftCardComponent from "components/gift-cards/GiftCardComponent";
import GiftCardValueSelector from "components/gift-cards/GiftCardValueSelector";
import Link from "next/link";
import RoundedButton from "components/RoundedButton";
import PersonalisationForm from "components/gift-cards/PersonalisationForm";
import { scrollToSection } from "utils/common";

const cardDesigns = [1, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14];

const ChooseGiftCardSection = ({ giftCardDetails, updateGiftCardProperty, onContinue }) => {
  const { cardDesign, durationInWeeks, toName, toEmailAddress, fromName } = giftCardDetails;

  const disabledContinueButton = !toName || toName.trim().length < 1 || !toEmailAddress || toEmailAddress.trim().length < 1 || !fromName || fromName.trim().length < 1;

  return (
    <>
      <div className='paddedMaxWidthContainer' style={{ marginTop: '1em', marginBottom: '40px' }}>
        <p style={{ textAlign: 'center', fontStyle: 'italic', fontSize: '1.3em', margin: '0.3em', fontWeight: 'bold' }}>
          More than
        </p>

        <h3 style={{ margin: 0, textShadow: `2px 2px ${colors.brand.pastel}` }}>
          Just A <strong>Gift</strong>
        </h3>

        <p>
          Give someone the chance to tick off their bucket list while planting trees in their name — better than socks we’d say!
        </p>
      </div>

      <div className='sectionContainer'>
        <GlowBar color='#DDD' style={{ marginBottom: '4em' }} />

        <img
          src={`${ASSET_PREFIX}/images/gift-cards/1.svg`}
          style={{
            height: '40px'
          }}
        />
        <h3>
          Choose A <strong>Design</strong>
        </h3>
        <CardList id='giftCardDesignsList'>
          { cardDesigns.map(number =>
            <GiftCardComponent
              key={number}
              glowing={number === cardDesign}
              cardDesignImage={`${ASSET_PREFIX}/images/gift-cards/card-designs/${number}.jpg`}
              onClick={() => {
                updateGiftCardProperty('cardDesign', number);
                scrollToSection('#chooseSubscriptionSection');
              }}
            />
          )}
        </CardList>

        <div className='paddedMaxWidthContainer' id='chooseSubscriptionSection'>
          <img
            src={`${ASSET_PREFIX}/images/gift-cards/2.svg`}
            style={{
              height: '40px',
              marginTop: '5em'
            }}
          />
          <h3>
            Choose A Gift Card <strong>Value</strong>
          </h3>

          <GiftCardValueSelector
            selectedDuration={durationInWeeks}
            onSelectHandler={(newDuration) => {
              updateGiftCardProperty('durationInWeeks', newDuration);
            }}
            style={{
              margin: '1.4em 0'
            }}
          />

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4em', width: '96%', maxWidth: '380px' }}>
            <h4 style={{ textAlign: 'left', margin: 0, fontSize: '1.2em' }}>
              {durationInWeeks} Week <strong>Subscription</strong>
            </h4>
            <p style={{ margin: 0, fontWeight: 800 }}>
              £{durationInWeeks * 2.5}
            </p>
          </div>

          <div className='separator' style={{ width: '96%', backgroundColor: 'gray', margin: '1.2em 0', maxWidth: '390px' }} />

          <div style={{ width: '100%', fontWeight: 600, fontStyle: 'italic', margin: '0.5em 0 0.8em 0', maxWidth: '390px', fontSize: '1.2em' }}>
            <img src={`${ASSET_PREFIX}/images/gift-cards/entries.svg`} style={{ float: 'left', marginRight: '0.8em', height: '25px' }} />
            {durationInWeeks} draw entries (1 per week)
          </div>

          <div style={{ width: '100%', fontWeight: 600, fontStyle: 'italic', maxWidth: '390px', fontSize: '1.2em' }}>
            <img src={`${ASSET_PREFIX}/images/gift-cards/trees.svg`} style={{ float: 'left', marginRight: '0.8em', height: '25px' }} />
            {durationInWeeks} trees planted with {''}
            <Link href='/giving-back'>
              <a style={{ margin: 0, fontWeight: 800 }}>
                veritree
              </a>
            </Link>
            {''}
          </div>

          <div style={{ width: '100%', fontWeight: 600, fontStyle: 'italic', margin: '1.5em 0 0.8em 0', maxWidth: '390px', fontSize: '1em' }}>
            Gift cards can be redeemed any time within 12 months of the purchase date.
          </div>

          <img
            src={`${ASSET_PREFIX}/images/gift-cards/3.svg`}
            style={{
              height: '40px',
              marginTop: '7em'
            }}
          />
          <h3>
            Make It <strong>Personal</strong>
          </h3>

          <PersonalisationForm
            giftCardDetails={giftCardDetails}
            updateGiftCardProperty={updateGiftCardProperty}
          />

          <div className='separator' style={{ width: '96%', backgroundColor: 'gray', margin: '1.2em 0', maxWidth: '390px' }} />

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '0em', width: '96%', maxWidth: '380px' }}>
            <h4 style={{ textAlign: 'left', margin: 0, fontSize: '1.2em' }}>
              TOTAL:
            </h4>
            <p style={{ margin: 0, fontWeight: 800 }}>
              £{durationInWeeks * 2.5}
            </p>
          </div>

          <RoundedButton onClick={onContinue} disabled={disabledContinueButton} style={{ textTransform: 'uppercase', marginTop: '3em', minWidth: '280px' }}>
            Review Your Order
          </RoundedButton>
        </div>

        <GlowBar color='#DDD' direction='up' marginTop='4em' />
      </div>

      <style jsx>{`
        h3 {
         font-size: 1.4em;
        }
      
        p {
          text-align: center;
          margin: 10px;
          font-size: 1.2em;
          font-weight: 600;
        }

        a {
          margin: 0;
          font-weight: bold;
        }

        :global(.footer) {
          margin-top: 0!important;
        }
      `}</style>
    </>
  );
}

export default ChooseGiftCardSection;
